import { connect } from 'react-redux'

import { notify } from 'Actions/notifications'
import DougsForm from '@components/forms/DougsForm'
import axiosClient from '@api/axios-client'

const ComptabilitePage = ({ dispatch }) => {
  const onClick = async () => {
    try {
      await axiosClient.post('/api/partners/dougs')
      dispatch(notify('success', 'Votre demande a bien été prise en compte.'))
    } catch (error) {
      dispatch(notify('error', 'Une erreur est survenue, votre demande n\'a pu être prise en compte, merci de réessayer ultérieurement.'))
    }
  }

  return (
    <div className="max-w-[600px] mt-4 mx-auto">
      <DougsForm
        setSelected={onClick}
        singleButton
      />
    </div>
  )
}

export default connect()(ComptabilitePage)